/**
 * Add custom functions to the `functions` object in order to make them callable
 */
const functions = {};

functions.orderedAreaM2 = (data, parentData) => {
    try {
        var infoBoardDOMElement = jQuery(".nestable-item-" + parentData.id);

        var theField = jQuery(infoBoardDOMElement).find(".js-orderedAreaM2");

        if (theField.length > 0) {
            var val = jQuery(theField).val();
            if (val != 0) {
                return parseFloat(val);
            }
        }
    } catch (e) { }

    return parseFloat(data.quantity);
};

functions.orderedAreaM2Rounded = (data, parentData) => {
    return Math.round(functions.orderedAreaM2(data, parentData));
};

functions.materialAreaM2 = (data, parentData) => {
    try {

        var infoBoardDOMElement = jQuery(".nestable-item-" + parentData.id);
        var theField = jQuery(infoBoardDOMElement).find(".js-materialAreaM2");

        if (theField.length == 0) {
            var isMultiMode = jQuery(infoBoardDOMElement).find('input[name="rows[0][infoboarddata][numDynamicRows]"]').length > 0;
            if (isMultiMode) {
                theField = jQuery(infoBoardDOMElement).find('.js-orderedAreaM2WithWaste');
            }
        }

        if (theField.length > 0) {
            var val = jQuery(theField).val();
            if (val != 0) {
                return parseFloat(val);
            }
        }
    } catch (e) { }

    return parseFloat(data.quantity);
};

functions.materialAreaM2Rounded = (data, parentData) => {
    return Math.round(functions.materialAreaM2(data, parentData));
};

functions.circumference = (data, parentData) => {
    try {
        var infoBoardDOMElement = jQuery(".nestable-item-" + parentData.id);

        var theField = jQuery(infoBoardDOMElement).find(".js-circumference");

        if (theField.length > 0) {
            var val = jQuery(theField).val();
            if (val != 0) {
                return parseFloat(val);
            }
        }
    } catch (e) { }

    return parseFloat(data.quantity);
};

functions.circumferenceRounded = (data, parentData) => {
    return Math.round(functions.circumference(data, parentData));
};

functions.circumferenceTimesTwo = (data, parentData) => {
    return functions.circumference(data, parentData) * 2;
};

functions.circumferenceTimesTwoRounded = (data, parentData) => {
    return Math.round(functions.circumference(data, parentData) * 2);
};

functions.circumferenceTimesThree = (data, parentData) => {
    return functions.circumference(data, parentData) * 3;
};

functions.circumferenceTimesThreeRounded = (data, parentData) => {
    return Math.round(functions.circumference(data, parentData) * 3);
};

functions.totalCircumference = (data, parentData) => {
    try {
        var infoBoardDOMElement = jQuery(".nestable-item-" + parentData.id);

        var theField = jQuery(infoBoardDOMElement).find(
            ".js-totalCircumference"
        );

        if (theField.length > 0) {
            var val = jQuery(theField).val();
            if (val != 0) {
                return parseFloat(val);
            }
        }
    } catch (e) { }

    return parseFloat(data.quantity);
};

functions.totalCircumferenceRounded = (data, parentData) => {
    return Math.round(functions.totalCircumference(data, parentData));
};

functions.seam = (data, parentData) => {
    try {
        var infoBoardDOMElement = jQuery(".nestable-item-" + parentData.id);

        var theField = jQuery(infoBoardDOMElement).find(".js-seam");

        if (theField.length > 0) {
            var val = jQuery(theField).val();
            if (val != 0) {
                return parseFloat(val);
            }
        }
    } catch (e) { }

    return parseFloat(data.quantity);
};

functions.seamRounded = (data, parentData) => {
    return Math.round(functions.seam(data, parentData));
};

/**
 * Set up the calculator service
 * @param data
 */
function infoBoardsCalc(data) {
    this.callable = null;
    this.data = {};
    this.parentData = {};

    this.setup = data => {
        this.data = { ...data };
        const fn = this.data.auto_calculate_function_name;

        if ("string" === typeof fn && "function" === typeof functions[fn]) {
            this.callable = functions[fn];
        } else {
            const event = new CustomEvent("cost-estimate:warnAutoCalculateFunctionNotFound", { 'detail': this.data.id });
            window.dispatchEvent(event);
        }
    };

    this.setParentData = data => {
        this.parentData = { ...data };
    };
}

infoBoardsCalc.prototype.getQuantity = function () {
    const { data, parentData } = this;
    let value = parseFloat(data.quantity);

    if ("function" === typeof this.callable) {
        value = this.callable(data, parentData);
    }

    if (Number.isNaN(value)) {
        value = 0.0;
    }

    return parseFloat(value.toFixed(4));
};

export default infoBoardsCalc;
